import * as SceneUtils from './components/viewer/utils/sceneUtils';
import * as FlagsModule from './flags/flagsModule';
import * as sceneRenderable from './renderables/sceneRenderable';
import * as multiViewElement from './multiViewElement';
import * as multiViewRendererContext from './multiViewRendererContext';
import * as sceneViewerConfig from './sceneViewerConfig';
import * as sceneViewerContext from './sceneViewerContext';

export * from './components/viewer/tools/cameraTool';
export * from './components/viewer/tools/gizmoTypes';
export * from './components/viewer/tools/selectionTool';
export * from './components/viewer/tools/transformTool';
export * from './components/viewer/viewer';
export * from './geometry/triMeshGrid2';
export * from './objects/filterObjects';
export * from './renderables/gizmo';
export * from './renderables/arrangementGizmo';
export * from './renderer3/meshes/threeBox';
export * from './renderer3/passes/threeOutlinePass';
export * from './renderer3/passes/threeMainRenderPass';
export * from './renderer3/threeRenderer';
export { load as loadAvatarGeometry } from './resources/avatarGeometryLoader';
export { load as loadGarmentGeometry } from './resources/garmentGeometryLoader';
export * from './resources/garmentGeometryTypes';
export * from './resources/logoTypes';
export * from './resources/materialTypes';
export * from './resources/resourceEvent';
export * from './resources/resourcesContext';
export * from './resources/textureTypes';
export * from './scene/pieceGeometryCache';
export * from './scene/sceneGeometryCache';
export * from './scene/sceneGeometryModule';
export * from './scene/sceneTypes';
export * from './sceneReconciler/sceneReconciler';
export * from './sceneReconciler/visibilityState';
export * from './theme/themeColors';
export * from './theme/themeTypes';
export * from './utils/cameraUtils';

export type MultiViewElement = multiViewElement.MultiViewElement;
export type MultiViewRendererContext = multiViewRendererContext.MultiViewRendererContext;
export type SceneRenderable = sceneRenderable.SceneRenderable;
export type SceneViewerConfig = sceneViewerConfig.SceneViewerConfig;
export type SceneViewerContext = sceneViewerContext.SceneViewerContext;

export {
  FlagsModule,
  SceneUtils,
  multiViewElement,
  multiViewRendererContext,
  sceneRenderable,
  sceneViewerContext,
};
